<div fxLayout="column" style="width:28vw" fxLayoutGap="15px">
    <div>
        <label class="label-header">Do you wish to <span class="reject">Reject</span> the verification request? </label>
    </div>
    <div fxLayout="column">
        <label class="sub-header"> If yes, then add a reason for denial and submit.</label>
        <div fxLayout="column" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutAlign="center center" class="reject-comments-input">
            <input fxFlex="100" class="dialog-input" placeholder="Type your comments here" type="text" [(ngModel)]="rejectedReason" />
            <div fxLayout="row" fxLayoutAlign="end center" style="margin-right:5px;" *ngIf="rejectedReason">
                <mat-icon  (click)="clearInput()" style="cursor: pointer; position: absolute;color: #386AF6;font-size:20px;font-weight:700;margin:15px 10px 10px 10px;">
                    close</mat-icon>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
            <button type="button" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
                style="padding:10px 0;" (click)="closePopup()">Cancel
    
            </button>
            <button type="button" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
                style="padding:10px 0;background: #386AF6; color:#fff"  (click)="rejectTemplate()">Submit</button>
    
        </div>
    </div>
    
    
    </div>
</div>